import React, { useEffect, useState } from "react";
import Link from "admin/shared/ui/Link.Component";

import { Button, Card, CardContent } from "@material-ui/core";
import TableNew, { CELL_TYPES } from "../../../shared/Table";
import { AmlWarningsActions } from "./AmlWarnings.Actions";
import { AmlWarningsDetails } from "./AmlWarnings.Details";
import { compose } from "redux";
import amlConnector from "../../../services/aml/amlConnector";
import { amlStatuses } from "../amlStatuses";
import { filterTableService } from "../../../shared/Table/containers/Header.Filter";

import "./Aml.scss";

const WarningsComponent = ({
  amlWarnings,
  getAmlWarnings,
  getLoanstepAmlWarnings,
  getAmlStatuses,
  getLoanstepAmlStatuses,
  setAmlWarningStatus,
  setAmlWarningStatusAndCreateSendBackOrder,
  setLoanstepAmlWarningStatus,
  amlRules,
  getAmlRules,
  changeFilterValue,
  tables,
}) => {
  useEffect(() => {
    getAmlWarnings();
    getLoanstepAmlWarnings();
    getAmlRules();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  // Just so the filters are only fired once
  const [amlWarningsLoanstepFiltersSet, updateAmlWarningsLoanstepFiltersSet] =
    useState(false);
  const [amlWarningsFiltersSet, updateAmlWarningsFiltersSet] = useState(false);

  useEffect(() => {
    if (tables["aml_warnings_loanstep"] && !amlWarningsLoanstepFiltersSet) {
      changeFilterValue("CurrentStatus", "aml_warnings_loanstep", {
        ToBeVerified: true,
        UnderVerification: true,
      });
      updateAmlWarningsLoanstepFiltersSet(true);
    }

    if (tables["aml_warnings"] && !amlWarningsFiltersSet) {
      changeFilterValue("CurrentStatus", "aml_warnings", {
        ToBeVerified: true,
        UnderVerification: true,
      });
      updateAmlWarningsFiltersSet(true);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [tables]);

  let statusDict = {};
  amlStatuses.map((status) => {
    statusDict[status.value] = status.label;
  });

  let triggerDict = {};
  amlRules.data.map((status) => {
    const trigger = status.split(":")[0];
    triggerDict[trigger] = trigger;
  });

  const sharedColumns = [
    { key: "Id", label: "Id", visible: true, type: CELL_TYPES.text },
    { key: "Type", label: "Type", visible: true, type: CELL_TYPES.text },
    { key: "Created", label: "Created", visible: true, type: CELL_TYPES.date },
    {
      key: "CurrentStatus",
      label: "Status",
      visible: true,
      type: CELL_TYPES.enum,
      enumDict: statusDict,
    },
    {
      key: "Description",
      label: "Description",
      visible: true,
      type: CELL_TYPES.text,
    },
  ];

  const amlWarningsColumns = [
    ...sharedColumns,
    {
      key: "InvestorId",
      label: "InvestorId",
      visible: true,
      type: CELL_TYPES.text,
      renderer: (value) => {
        return (
          <Link toState={"userOverview"} parameters={["identity", value]}>
            {value}
          </Link>
        );
      },
    },
    { key: "Trigger", label: "Trigger", visible: true, type: CELL_TYPES.text },
    {
      key: "WithdrawalOrderId",
      label: "Withdrawal Id",
      visible: true,
      type: CELL_TYPES.text,
    },
    {
      key: "Id",
      label: "Actions",
      visible: true,
      filter: false,
      renderer: (value, item) => {
        return (
          <AmlWarningsActions
            item={item}
            value={value}
            investorDepositId={item.InvestorDepositId}
            setAmlWarningStatus={setAmlWarningStatus}
            setAmlWarningStatusAndCreateSendBackOrder={
              setAmlWarningStatusAndCreateSendBackOrder
            }
            includeBankAccount={item.Type === "Deposit"}
          />
        );
      },
    },
  ];

  const amlLoanstepWarningsColumns = [
    ...sharedColumns,
    {
      key: "BorrowerId",
      label: "BorrowerId",
      visible: true,
      type: CELL_TYPES.text,
      renderer: (value) => {
        return (
          <Link toState={"userOverview"} parameters={["identity", value]}>
            {value}
          </Link>
        );
      },
    },
    { key: "Trigger", label: "Trigger", visible: true, type: CELL_TYPES.text },
    {
      key: "Id",
      label: "Actions",
      visible: true,
      filter: false,
      renderer: (value, item) => {
        return (
          <AmlWarningsActions
            item={item}
            value={value}
            setAmlWarningStatus={setLoanstepAmlWarningStatus}
          />
        );
      },
    },
  ];

  const addMoreInfo = (item) => {
    getAmlStatuses(item.Id);
  };

  const addMoreInfoLoanstep = (item) => {
    getLoanstepAmlStatuses(item.Id);
  };

  const getDetails = (item) => {
    return <AmlWarningsDetails item={item} />;
  };

  if (!amlRules.fetched) return <div> Fetching aml Rules... please wait </div>;

  return (
    <React.Fragment>
      <Card>
        <CardContent>
          <div className="aml-text-header">Aml: Warnings</div>
          <Button
            variant="outlined"
            className="aml-button"
            onClick={() => getAmlWarnings()}
            style={{ zIndex: "1" }}
            color="primary"
          >
            REFRESH
          </Button>
          <TableNew
            columns={amlWarningsColumns}
            items={amlWarnings.data}
            showDetailsFun={addMoreInfo}
            actionColumnWidth={220}
            detailsRenderer={(item) => {
              return getDetails(item);
            }}
            tableKey="aml_warnings"
          />
        </CardContent>
      </Card>
      <br />
      <Card>
        <CardContent>
          <div className="aml-text-header">Loanstep Aml: Warnings</div>
          <Button
            variant="outlined"
            className="aml-button"
            onClick={() => getLoanstepAmlWarnings()}
            style={{ zIndex: "1" }}
            color="primary"
          >
            REFRESH
          </Button>
          <TableNew
            columns={amlLoanstepWarningsColumns}
            items={amlWarnings.lsData}
            showDetailsFun={addMoreInfoLoanstep}
            actionColumnWidth={220}
            detailsRenderer={(item) => {
              return getDetails(item);
            }}
            tableKey="aml_warnings_loanstep"
          />
        </CardContent>
      </Card>
    </React.Fragment>
  );
};

export default compose(amlConnector, filterTableService)(WarningsComponent);
